import React from 'react';
import {
  withStyles,
} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import Button from '@material-ui/core/Button';

import withForm from './FormMaster';

import { sendClaim } from '../../services/claims';

const styles = () => ({
  fields: {
    display: 'grid',
    width: 400,
    height: 300,
    gridTemplateRows: '1fr 1fr 2fr 60px',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: '20px',
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
  },
  description: {
    gridColumn: '1 / 3',
    gridRow: '3 / 4',
  },
  footer: {
    display: 'flex',
    height: 60,
    alignItems: 'center',
    gridRow: '4 / 5',
    gridColumn: '1 / 3',
    paddingLeft: 30,
    borderTop: '1px solid #EEE',
    backgroundColor: '#FAFAFA',
  },
});

const InternmentForm = ({classes, formInputData, handleChange, handleBlur, errors, formValid, onClose}) => {

  const handleSubmit = () => {
    sendClaim({
      description: formInputData.description,
      contact: {
        firstName: formInputData.firstName,
        lastName: formInputData.lastName,
        phone: formInputData.phoneNumber,
        email: formInputData.email,
      },
      type: 'public',
    });
    onClose();

  }

  return (
    <form noValidate autoComplete="off">
      <div className={classes.fields}>
        <FormControl error={errors.lastName.hasError}>
          <InputLabel htmlFor="lastName">Nume</InputLabel>
          <Input
            inputProps={{
              id: 'lastName',
              name: 'lastName',
            }}
            value={formInputData.lastName}
            onChange={handleChange}
            onBlur={() => handleBlur('lastName')}
          />
          <FormHelperText>{errors.lastName.message}</FormHelperText>
        </FormControl>
        <FormControl error={errors.firstName.hasError}>
          <InputLabel htmlFor="firstName">Prenume</InputLabel>
          <Input
            inputProps={{
              id: 'firstName',
              name: 'firstName',
            }}
            value={formInputData.firstName}
            onChange={handleChange}
            onBlur={() => handleBlur('firstName')}
          />
          <FormHelperText>{errors.firstName.message}</FormHelperText>
        </FormControl>
        <FormControl error={errors.phoneNumber.hasError}>
          <InputLabel htmlFor="phoneNumber">Numar telefon</InputLabel>
          <Input
            inputProps={{
              id: 'phoneNumber',
              name: 'phoneNumber',
            }}
            value={formInputData.phoneNumber}
            onChange={handleChange}
            onBlur={() => handleBlur('phoneNumber')}
          />
          <FormHelperText>{errors.phoneNumber.message}</FormHelperText>
        </FormControl>
        <FormControl error={errors.email.hasError}>
          <InputLabel htmlFor="email">Adresa email</InputLabel>
          <Input
            inputProps={{
              id: 'email',
              name: 'email',
            }}
            value={formInputData.email}
            onChange={handleChange}
            onBlur={() => handleBlur('email')}
          />
          <FormHelperText>{errors.email.message}</FormHelperText>
        </FormControl>
        <FormControl className={classes.description} error={errors.description.hasError}>
          <InputLabel htmlFor="description">Descriere simptom</InputLabel>
          <Input
            multiline
            rows={5}
            inputProps={{
              id: 'description',
              name: 'description',
            }}
            value={formInputData.description}
            onChange={handleChange}
            onBlur={() => handleBlur('description')}
          />
          <FormHelperText>{errors.description.message}</FormHelperText>
        </FormControl>
      </div>
      <div className={classes.footer}>
        <Button
          variant="contained"
          color="primary"
          disabled={!formValid}
          onClick={handleSubmit}
        >
          Salveaza
        </Button>
      </div>
    </form>
  );
};

const formConfig = {
  fields: {
    firstName: {
      required: true,
    },
    lastName: {
      required: true,
    },
    phoneNumber: {
      required: true,
    },
    email: {
      required: false,
    },
    description: {
      required: true,
    },
  },
  fieldErrorMessages: {
    firstName: {
      required: 'Introducerea prenumelui este obligatorie!',
      validation: '',
    },
    lastName: {
      required: 'Introducerea numelui este obligatorie!',
      validation: '',
    },
    phoneNumber: {
      required: 'Introducerea numarului de telefon este obligatorie!',
      validation: 'Numarul de telefon este invalid!',
    },
    email: {
      required: 'Introducerea email-ului este obligatorie!',
      validation: 'Adresa de email este invalida!',
    },
    description: {
      required: 'Introducerea descrierii simptomului este obligatorie!',
      validation: '',
    },
  },
  fieldValidators: {
    phoneNumber: inputValue => {
      // eslint-disable-next-line
      return inputValue.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/);
    },
    email: inputValue => {
      // eslint-disable-next-line
      return inputValue.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
  },
};

export default withForm(withStyles(styles)(InternmentForm), formConfig);